import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'

import { Observable } from 'rxjs'
import { ResponseModel } from '../domain/authentication.model'
import { CoreEnvironmentService } from './core-environment.service'

@Injectable({
  providedIn: 'root'
})
export class FollowService {
  baseUrl: string

  constructor(
    private http: HttpClient,
    private coreEnvironmentService: CoreEnvironmentService
  ) {
    this.baseUrl = this.coreEnvironmentService.getBaseURL()
  }

  follow(beatmakerId: number): Observable<ResponseModel> {
    return this.http.post<ResponseModel>(
      `${this.baseUrl}/web/v1/producers/follow/${beatmakerId}`,
      {},
      { withCredentials: true }
    )
  }

  unfollow(beatmakerId: number): Observable<ResponseModel> {
    return this.http.post<ResponseModel>(
      `${this.baseUrl}/web/v1/producers/unfollow/${beatmakerId}`,
      {},
      { withCredentials: true }
    )
  }
}
